module.exports = __webpack_public_path__ + "assets/icon-star-outline-component.3cdf14d7.svg";